import React from "react";
import TimeLineImage from "../../../assets/Images/TimelineImage.png";
import Desktop from "../../../assets/Images/desktop.png";
import Man1 from "../../../assets/Images/Man1.png";
import Logo1 from "../../../assets/TimeLineLogo/Logo1.svg";
import Logo2 from "../../../assets/TimeLineLogo/Logo2.svg";
import Logo3 from "../../../assets/TimeLineLogo/Logo3.svg";
import Logo4 from "../../../assets/TimeLineLogo/Logo4.svg";

const TimeLine = [
  {
    Logo: Logo1,
    Heading: "Leadership",
    Description: "Fully committed to the success company",
  },
  {
    Logo: Logo2,
    Heading: "Responsibility",
    Description: "Students will always be our top priority",
  },
  {
    Logo: Logo3,
    Heading: "Flexibility",
    Description: "The ability to switch is an important skills",
  },
  {
    Logo: Logo4,
    Heading: "Solve the problem",
    Description: "Code your way to a solution",
  },
];

const TimelineSection = () => {
  return (
    <div>
      <div className="flex flex-col lg:flex-row gap-20 mb-20 items-center">
        <div className="lg:w-[45%]  flex flex-col gap-14 lg:gap-3">
          {TimeLine.map((ele, i) => {
            return (
              <div className="flex flex-col lg:gap-3" key={i}>
                <div className="flex gap-6" key={i}>
                  <div className="w-[52px] h-[52px] bg-white rounded-full flex justify-center items-center 
                  shadow-[#00000012] shadow-[0_0_62px_0]">
                    <img src={ele.Logo} alt="" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-[18px]">{ele.Heading}</h2>
                    <p className="text-base">{ele.Description}</p>
                  </div>
                </div>
                <div
                  className={`hidden ${
                    TimeLine.length - 1 === i ? "hidden" : "lg:block"
                  }  h-14 border-dotted border-r border-richblack-100 bg-richblack-400/0 w-[26px]`}
                ></div>
              </div>
            );
          })}
        </div>
        {/* shadow-blue-200 shadow-[0px_0px_30px_0px] */}
        <div className="relative w-fit h-fit ">
          <div
            className="absolute left-[50%] bottom-0 translate-x-[-50%] translate-y-[50%]
           bg-caribbeangreen-700 flex lg:flex-row flex-col text-white uppercase py-5 gap-4 lg:gap-0 lg:py-10 "
          >
            {/* Section 1 */}
            <div className="flex gap-5 items-center lg:border-r border-caribbeangreen-300 px-7 lg:px-14 z-0">
              <h1 className="text-3xl font-bold w-[100px]">10</h1>
              <h1 className="text-caribbeangreen-300 text-sm w-[100px]">
                Years experiences
              </h1>
            </div>

            {/* Section 2 */}
            <div className="flex gap-5 items-center lg:px-14 px-7">
              <h1 className="text-3xl font-bold w-[100px]">250</h1>
              <h1 className="text-caribbeangreen-300 text-sm w-[100px]">
                types of courses
              </h1>
            </div>
            <div></div>
          </div>
          {/* shadow-black shadow-[0px_20px_0px_0px]   */}
          <div className=" w-[710px] aspect-[calc(710/538)] flex justify-center relative z-10 ">
            <img
              src={Man1}
              alt="timelineImage"
              className="-scale-x-100 h-4/5 lg:h-fit"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineSection;
